/* eslint-disable import/no-anonymous-default-export */
import { OrganizationList } from './OrganizationList';
import { OrganizationShow } from './OrganizationShow';
import { OrganizationEdit } from './OrganizationEdit';
import type { Organization } from '@wwf/sdk';

export default {
    list: OrganizationList,
    show: OrganizationShow,
    edit: OrganizationEdit,
    recordRepresentation: (_record: Organization) => 'Organization',
};
